<template>
  <ga-product-card-favorite
    v-if="postRendered"
    :data="dataFavorite"
    v-bind="propsToPass"
    @click="onFavoriteClick"
  />
</template>

<script src="./favorite-adapter.scripts.js" />
